export default __webpack_public_path__ + "static/media/banner-05_644x450_crop_center.491b79b0.jpg";